import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

function setMetaTag(name: string, content: string) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

/**
 * Sets the current page's title and meta description / keywords (client-side SEO).
 * The home page keeps the values defined in index.html.
 */
export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    if (description) setMetaTag('description', description);
    if (keywords) setMetaTag('keywords', keywords);
  }, [title, description, keywords]);
}

export default usePageMeta;